// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__EuET_","container":"styles_container__z_7lT","actions":"styles_actions__4b2S3","icon":"styles_icon__nNqyJ","divider":"styles_divider__PN7iq"};